// extracted by mini-css-extract-plugin
module.exports = {"list":"tags-module--list--1nmxk","item":"tags-module--item--1AOdS","upperCase":"tags-module--upperCase--2bqlk"};